//
// VisualElementTypeInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "./VisualElementType";
import "@sas-dvr/ltjs-gtl/models/GraphDescription";

var VisualElementTypeInfo = createModule("BIRD::VisualElementTypeInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        localizedName: 7,
        graphDescription: 4,
        type: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default VisualElementTypeInfo;
